import React from 'react'

export default function Home() {
  return (
		<>
			<div className="home">
        <div className="aboutme">
          <div>
          <span>Nikhil Shekhawat</span>
          <span> Hi, I am a full stack web developer , I specialize in creating dynamic and interactive websites utilizing a range of programming languages and frameworks</span>
          </div>
        </div>
			</div>
		</>
	);
}
